import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, LOCALE_ID } from '@angular/core'; //LOCALE_ID

import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';

import { FormsModule } from '@angular/forms';
import { AppRoutingModule, routes } from './app-routing.module';

import { AppComponent } from './app.component';
import { provideRouter } from '@angular/router';
import { AuthInterceptor } from './spinner.interceptor';
import { OpsNumberDirective, LegacyComponentsModule } from '@ops/components';
import { LoadingService } from '@ops/shared-types';
import { OrderModule } from 'ngx-order-pipe';
import { OpsLoginComponent, OpsSubscriptionModalWrapper } from '@ops/storybook';
import { NgxsModule } from '@ngxs/store';
import {
  SettingsEditState,
  PaymentMethodsState,
  PaymentMethodsEffects,
  PaymentMethodsManagerService,
  EnhancedEnumService,
  CompanyChangeListenerService
} from '@ops/services';
import { SpinnerComponent } from 'legacy/shared/components/src/lib/spinner/spinner.component';

import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClientModule, HttpClient } from '@angular/common/http';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    FormsModule,
    OrderModule,
    BrowserAnimationsModule,
    OpsNumberDirective,
    LegacyComponentsModule,
    OpsSubscriptionModalWrapper,
    OpsLoginComponent,
    SpinnerComponent,
    AppRoutingModule,
    NgxsModule.forRoot([SettingsEditState, PaymentMethodsState]),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
      deps: [LoadingService],
    },
    { provide: LOCALE_ID, useValue: 'en' },
    provideRouter(routes),
    provideHttpClient(withInterceptorsFromDi()),
    PaymentMethodsEffects,
    PaymentMethodsManagerService,
    EnhancedEnumService,
    CompanyChangeListenerService,
  ],
})
export class AppModule {}
